import { startOfDay } from "date-fns";
import type { TOptions } from "i18next";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { ResourceKey } from "web_myplann/Reminders/Types/ReminderTypes";
import { isSnoozeDateAfterReminder } from "web_myplann/Reminders/Utils/snoozeDates";
import { z } from "zod";

type TranslateFn = (key: ResourceKey, options?: TOptions) => string;

export const getReminderSnoozeSchema = (t: TranslateFn, reminderDate: Date) =>
	z
		.object({
			snoozedUntil: z
				.date({
					invalid_type_error: t(Resources.Reminders.Validations.dateRequired),
				})
				.nullable(),
		})
		.superRefine((data, ctx) => {
			if (data.snoozedUntil === null) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ["snoozedUntil"],
					message: t(Resources.Reminders.Validations.dateRequired),
				});
				return;
			}

			if (
				startOfDay(data.snoozedUntil).getTime() <=
				startOfDay(new Date()).getTime()
			) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ["snoozedUntil"],
					message: t(Resources.Reminders.Validations.dateFuture),
				});
				return;
			}

			if (!isSnoozeDateAfterReminder(data.snoozedUntil, reminderDate)) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ["snoozedUntil"],
					message: t(Resources.Reminders.Validations.dateAfterReminder),
				});
			}
		});

export type ReminderSnoozeFormModel = z.infer<
	ReturnType<typeof getReminderSnoozeSchema>
>;
